<template>
  <!--pages/rank/index.wxml-->
<div class="rank-page scroll-view" v-scroll-bottom="loadMoreData">
    <div class="rank-header">
        <div class="rank-title">实时榜单</div>
        <div class="flex">
            <div class="rank-subtitle">看实时榜单，推广更易赚钱</div>
        </div>
        <div class="rank-category">
            <!-- 引入category 组件 -->
            <CategoryWidget class="rank-category" :current="currentCategory" :list="categoryList" @onCategory="handleCategory"></CategoryWidget>
        </div>
    </div>
    <div class="rank-content">
        <div class="rank-tab">
            <span v-for="(item,index) in rankBys" class="rank-tab-item" :class="rankBy ==item.value && rankDuration ==''? 'active' :''" :key="index" @click="handleRank(item.value)">{{ item.text }}</span>
            <span v-for="(item, index) in rankDurations" class="rank-tab-item" :class="rankDuration ==item.value ? 'active' :''" :key="index" @click="handleRank(item.value)">{{ item.text }}</span>
            <!-- <span class="rank-tab-item {{rankBy =='commissionShare' ? 'active' :''}}" data-value="commissionShare" bind:tap="handleRank">高佣榜</span>


            <span class="rank-tab-item {{rankDuration =='24h' ? 'active' :''}}" data-value="24h" bind:tap="handleRank">24小时热销</span>
            <span class="rank-tab-item {{rankDuration =='72h' ? 'active' :''}}" data-value="72h" bind:tap="handleRank">72小时热销</span>
            <span class="rank-tab-item {{rankDuration =='1week' ? 'active' :''}}" data-value="1week" bind:tap="handleRank">一周热销</span> -->
            <!-- <span class="rank-tab-item">今日热销榜</span> -->
        </div>
        <!-- 引入goodlist 组件-->
        <good-list :is-rank="true" :product-list="productList" :has-more="hasMore"></good-list>
    </div>
</div>
</template>
<script>
import CategoryWidget from '@/components/category/CategoryWidget.vue';
import GoodList from '@/components/list/GoodList.vue';
import { getCategoryList } from '@/services/product';
import productHelper from '@/helpers/productHelper';

export default {
  name: 'RankView',
  components: {
    CategoryWidget,
    GoodList
  },
  data() {
    return {
      productList: [],
      hasMore: false,
      currentCategory: {
          cidName: '全部',
          cid: '-1'
      },
      page: 1,
      rankBy: 'estimateValidOrders',
      rankDuration: '',
      categoryList: [
          {
              cidName: '全部',
              cid: '-1'
          }
      ],
      rankDurations:[],
      rankBys: [{value: 'estimateValidOrders', text: '热销总榜'}, {value: 'estimateValidOrders_24', text: '24小时热销'},{value: 'estimateValidOrders_72', text: '72小时热销'},{value: 'estimateValidOrdersWeek', text: '一周热销'},{value: 'commissionShare', text: '高佣榜'}]
    }
  },
  created() {
    getCategoryList({}).then(res => {
      res.data.forEach(it => {
        this.categoryList.push(it)
      })
      this.currentCategory = this.categoryList[0]
      this.handleCategory(this.currentCategory)
    })
  },
  methods: {
    loadMoreData() {
      this.page++
      productHelper.getProductList(this)
    },
    handleCategory(e) {
      this.currentCategory = e
      this.page = 1
      this.productList = []
      productHelper.getProductList(this)
    },
    handleRank(e){
        //console.log(e)
        this.page = 1
        this.productList = []
        const tabValue = e
        const includeDuration = this.rankDurations.filter(i => i.value == tabValue )[0] 
        if(includeDuration) {
          this.rankBy = 'estimateValidOrders'
          this.rankDuration = includeDuration.value
        } else {
          this.rankBy = tabValue
          this.rankDuration = ''
        }
        productHelper.getProductList(this)
    }
  }
}
</script>
<style scoped>
/* pages/rank/index.wxss */
.flex{
    display: flex;
}
.rank-header{
    height: var(--len130);
    background-color: var(--primary-color);
    position: relative;
}
.bg-transparent{
    background-color: transparent!important;
}
.rank-category-item{
    color: white!important;
}
.rank-active{
    border-bottom: 2px solid rgb(102, 75, 1)!important;
    color: rgb(102, 75, 1)!important;
}
.rank-header .rank-title{
    color: white;
    text-align: center;
    padding-top: 0px;
    font-size: var(--len20);
    font-weight: bold;
}
.rank-content{
    /* background-color: rgba(0, 0, 0, 0.05); */
    padding: 0 var(--len10);
}
.rank-category{
    width: 100%;
    /* height: ; */
    position: absolute;
    bottom: 0px;
    /* margin-top: 5px;
     */
}
.rank-header .rank-subtitle {
    position: relative;
    color: rgb(102, 75, 1);
    text-align: center;
    font-size: var(--len14);
    font-weight: bold;
    display: inline-block;
    width: var(--len250);
    height: var(--len25);
    line-height: var(--len25);
    border: 1px solid white;
    margin: 0 auto;
    text-align: center;
    margin-top: var(--len20);
    margin-bottom: var(--len10);
    border-left: none;
    border-right: none;
    position: relative;
}
.rank-header .rank-subtitle::before{
    content: '';
    position: absolute;
    top: var(--len3);
    left: calc(0px - var(--len10));
    width: 1.125rem;
    height: 1.125rem;
    transform: rotate(-135deg);
    border-top: 1px solid white;
    border-right: 1px solid white;
}
.rank-header .rank-subtitle::after{
    content: '';
    position: absolute;
    top: var(--len3);
    right: calc(0px - var(--len10));
    width: 1.125rem;
    height: 1.125rem;
    transform: rotate(45deg);
    border-top: 1px solid white;
    border-right: 1px solid white;
}
.rank-tab{
    padding: var(--len10) 0 0px 0px;
    display: flex;
}
.rank-tab .rank-tab-item{
    padding: 0 var(--len5);
    /* flex: 1; */
    font-size: var(--len14);
    text-align: center;
}
.rank-tab .rank-tab-item.active{
    color: var(--primary-color);
}
</style>